import React from "react";
import Search from "../../Search";

const ClassActivityHeader = ({ onSearch }) => {
  return (
    <div>
      <div className="flex gap-6 items-center mb-4">
        <h1 className="text-[20px] font-bold text-[#400167] font-satoshi">
          VCL Class Activity
        </h1>
        <Search onSearch={onSearch} />
      </div>
      <div className="bg-[#ffffff] w-full shadow-md mb-4 rounded-t-lg text-[#ffffff]">
        <div className="bg-img h-[152px] bg-cover bg-no-repeat w-full px-8 py-4">
          <h2 className="text-[24px] font-bold font-satoshi">Classroom Name</h2>
          <p className="w-[40%] mt-3 font-light font-satoshi">
            Lorem ipsum dolor sit amet consectetur. Proin libero morbi nulla
            morbi urna mauris volutpat sed lobortis. Quis purus lacinia te
          </p>
        </div>
        <div className="flex justify-between items-center mt-3 px-8 py-3">
          <div className="flex items-center text-black">
            <img src="../assets/UserGroup.png" alt="User Icon" />
            <span className="ml-3 font-semibold">+20</span>
          </div>
          <span className="text-black font-light">
            <span className="font-bold font-satoshi">Date Created:</span> 13th
            May, 2024
          </span>
        </div>
      </div>
    </div>
  );
};

export default ClassActivityHeader;
